module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap1"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('i', [_vm._v("At North Farm")])])]), _c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Somewhere someone is traveling furiously toward you,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("At incredible speed, traveling day and night,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Through blizzards and desert heat, across torrents, through narrow passes.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("But will he know where to find you,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Recognize you when he sees you,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Give you the thing he has for you?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Hardly anything grows here,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Yet the granaries are bursting with meal,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("The sacks of meal piled to the rafters.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("The streams run with sweetness, fattening fish;")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Birds darken the sky. Is it enough")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("That the dish of milk is set out at night,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("That we think of him sometimes,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Sometimes and always, with mixed feelings?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c454a08c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5chap1.vue
// module id = 72
// module chunks = 0